module.exports = __webpack_public_path__ + "img/01-4.12df80fb.png";